
.headerToggleContainer {
  background-color: var(--static-background-weak);
  border-radius: 0.375rem;
  padding: 0.125rem;
  border: 1px solid var(--static-divider-standard);
  margin-bottom: 2rem;
}

.headerToggleButton {
  height: 2rem;
  flex: 1 1 0;
  font: inherit;
  background: none;
  border: none;
  color: var(--static-text-strong);
  border-radius: 0.375rem;
  cursor: pointer;
}

.headerToggleButtonSelected {
  background-color: var(--color-primary);
  box-shadow: 0.125rem 0.125rem 0.125rem var(--static-divider-standard);
}
